import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../environments/environment";

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(private http: HttpClient) { }

  checkSession(): Observable<any> {
    return this.http.get(`${environment.backendUrl}/authentication/authenticated`, {
      withCredentials: true
    });
  }

  login(returnUrl: string): void {
    window.location.assign(`${environment.backendUrl}/authentication/login?returnUrl=${encodeURIComponent(returnUrl)}`);
  }

  logout(returnUrl: string): void {
    window.location.assign(`${environment.backendUrl}/authentication/logout?returnUrl=${encodeURIComponent(returnUrl)}`);
  }
}
